export default __webpack_public_path__ + "static/media/OT.4697d86f.jfif";